import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import StepsViewer from '../StepsViewer';
import { allSteps, getMainConfig } from '../../../../redux/stepsSlice';
import { setSteps, setConfig, setLoading } from '../../../../redux/walkthroughPreviewSlice';

// Walkthrough Editor v2 — live in-editor preview.
// Reuses the learner-facing StepsViewer, but feeds it the editor's *current*
// in-memory steps + appearance config (state.base) instead of fetching the
// saved version from the server. So edits — especially Appearance colours and
// fonts — reflect in the preview in real time, with the inspector still open.
// The hub-only response/progress calls inside StepsViewer are gated on a
// '/hub' path, which the editor URL is not, so nothing is persisted here.

const WalkthroughLivePreview = () => {
  const dispatch = useDispatch();
  const steps = useSelector((state) => allSteps(state));
  const config = useSelector((state) => getMainConfig(state));

  useEffect(() => { dispatch(setLoading(false)); }, [dispatch]);
  useEffect(() => { dispatch(setSteps(steps || [])); }, [steps, dispatch]);
  useEffect(() => { dispatch(setConfig(config)); }, [config, dispatch]);

  return (
    <div className="un-we-preview">
      <StepsViewer />
    </div>
  );
};

export default WalkthroughLivePreview;
